import PropTypes from 'prop-types'

import { getEventFiles, noop } from 'utils'
import { forwardRef } from 'react'

const FileInput = forwardRef(
  (
    {
      id,
      className,
      children,
      onChange = noop,
      onFileChange = noop,
      disabled,
      accept,
      multiple,
      clearFiles,
      hidden = true,
    },
    ref
  ) => (
    <>
      <label
        onDragOver={e => e.preventDefault()}
        onClick={e => {
          e.stopPropagation()
          e.currentTarget.click()
        }}
        onDrop={e => {
          e.preventDefault()
          const files = getEventFiles(e)
          onFileChange(files)
        }}>
        <input
          ref={ref}
          id={id}
          className={className}
          type="file"
          style={hidden ? { display: 'none' } : {}}
          onClick={e => e.stopPropagation()}
          onChange={e => {
            onChange(e)
            onFileChange(Array.from(e.target.files))
            if (clearFiles) e.target.value = ''
          }}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
        />
        {children}
      </label>
    </>
  )
)

FileInput.displayName = 'FileInput'
FileInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  children: PropTypes.node,
  multiple: PropTypes.bool,
  clearFiles: PropTypes.bool,
  onChange: PropTypes.func,
  onFileChange: PropTypes.func,
  onInput: PropTypes.func,
  hidden: PropTypes.bool,
}

export default FileInput
